import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { FormErrorModule } from '../form-error/form-error.module';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SharedDirectiveModule } from '@railmybox/shared/directive';

@NgModule({
  declarations: [TextareaComponent],
  imports: [CommonModule, FormErrorModule, FormsModule, SharedDirectiveModule, NgxMaskDirective, NgxMaskPipe],
  exports: [TextareaComponent],
  providers: [provideNgxMask()],
})
export class TextareaModule {}
